import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import App from "./App";
import theme from "./theme";
import ContextProvider from "./ContextProvider";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
    "pk_test_51ISGZjBSwptyH6P9avaEs4P4sLqOWQhNrrMOhrBbfODRaq8HbRkURmaB4BHsq9ocZJVfoq4yKIU7SVzixcd7OEgp00wwrv45xH"
);

ReactDOM.render(
    <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <ContextProvider>
            {/* <Elements stripe={stripePromise}> */}
            <App />
            {/* </Elements> */}
        </ContextProvider>
    </ThemeProvider>,
    document.querySelector("#root")
);
